import Vue from 'vue'

export const fetchAllResults = async (endpoint, params = {}) => {
  let limit = 1000

  const get = () => Vue.$http.get(endpoint, { params: { ...params, page_size: limit } })

  let result = await get()

  if (result.count > limit) {
    limit = result.count
    result = await get()
  }

  return result
}
